function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(0.040000, 0.880000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M-7.10542736e-15,-7.10542736e-15 L47.39,-7.10542736e-15 C71.16,-7.10542736e-15 103.56,5.9 103.56,36.7 C103.56,49.14 97.66,58.08 89.04,64.14 L115.37,115.52 L65.43,115.52 L48.2,77.54 L47.56,77.54 L47.56,115.52 L-7.10542736e-15,115.52 L-7.10542736e-15,-7.10542736e-15 Z M51.06,51.06 C58.56,51.06 61.91,47.07 61.91,42.12 C61.91,37.17 58.4,33.34 51.06,33.34 L47.55,33.34 L47.55,51.05 L51.06,51.05 L51.06,51.06 Z",
  id: "Shape"
}), React.createElement("polygon", {
  id: "Path",
  points: "117.11 -7.10542736e-15 200.24 -7.10542736e-15 200.24 38.61 164.66 38.61 164.66 44.83 193.38 44.83 193.38 72.28 164.66 72.28 164.66 78.82 202.48 78.82 202.48 115.52 117.11 115.52 117.11 -7.10542736e-15"
}), React.createElement("path", {
  d: "M211.1,-1.42108547e-14 L254.82,-1.42108547e-14 C282.58,-1.42108547e-14 313.7,7.98 313.7,41.01 C313.7,70.69 288.81,82.66 260.24,82.66 L258.64,82.66 L258.64,115.53 L211.09,115.53 L211.09,-1.42108547e-14 L211.1,-1.42108547e-14 Z M259.92,53.3 C268.06,53.3 271.89,48.99 271.89,43.56 C271.89,38.14 267.9,33.83 259.92,33.83 L258.64,33.83 L258.64,53.3 L259.92,53.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M342.73,-1.42108547e-14 L388.21,-1.42108547e-14 L432.25,115.53 L380.87,115.53 L376.88,100.37 L350.39,100.37 L345.92,115.53 L298.69,115.53 L342.73,-1.42108547e-14 Z M369.22,71.33 L364.11,47.87 L363.79,47.87 L358.68,71.33 L369.22,71.33 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M437.03,-7.10542736e-15 L484.42,-7.10542736e-15 C508.19,-7.10542736e-15 540.59,5.9 540.59,36.7 C540.59,49.14 534.69,58.08 526.07,64.14 L552.4,115.52 L502.46,115.52 L485.23,77.54 L484.59,77.54 L484.59,115.52 L437.04,115.52 L437.04,-7.10542736e-15 L437.03,-7.10542736e-15 Z M488.09,51.06 C495.59,51.06 498.94,47.07 498.94,42.12 C498.94,37.17 495.43,33.34 488.09,33.34 L484.58,33.34 L484.58,51.05 L488.09,51.05 L488.09,51.06 Z",
  id: "Shape"
}), React.createElement("polygon", {
  id: "Path",
  points: "554.15 -7.10542736e-15 637.28 -7.10542736e-15 637.28 38.61 601.7 38.61 601.7 44.83 630.42 44.83 630.42 72.28 601.7 72.28 601.7 78.82 639.52 78.82 639.52 115.52 554.15 115.52"
}), React.createElement("polygon", {
  id: "Path",
  points: "648.13 -7.10542736e-15 731.26 -7.10542736e-15 731.26 38.61 695.68 38.61 695.68 44.83 724.4 44.83 724.4 72.28 695.68 72.28 695.68 78.82 733.5 78.82 733.5 115.52 648.13 115.52"
}), React.createElement("path", {
  d: "M742.11,-7.10542736e-15 L789.5,-7.10542736e-15 C813.28,-7.10542736e-15 845.67,5.9 845.67,36.7 C845.67,49.14 839.77,58.08 831.15,64.14 L857.48,115.52 L807.53,115.52 L790.3,77.54 L789.66,77.54 L789.66,115.52 L742.11,115.52 L742.11,-7.10542736e-15 Z M793.17,51.06 C800.67,51.06 804.02,47.07 804.02,42.12 C804.02,37.17 800.51,33.34 793.17,33.34 L789.66,33.34 L789.66,51.05 L793.17,51.05 L793.17,51.06 Z",
  id: "Shape"
}), React.createElement("polygon", {
  id: "Path",
  points: "903.91 -7.10542736e-15 951.46 -7.10542736e-15 951.46 35.74 975.39 35.74 975.39 -7.10542736e-15 1022.94 -7.10542736e-15 1022.94 115.52 975.39 115.52 975.39 73.39 951.46 73.39 951.46 115.52 903.91 115.52 903.91 -7.10542736e-15"
}), React.createElement("polygon", {
  id: "Path",
  points: "1033.79 -7.10542736e-15 1116.92 -7.10542736e-15 1116.92 38.61 1081.34 38.61 1081.34 44.83 1110.06 44.83 1110.06 72.28 1081.34 72.28 1081.34 78.82 1119.16 78.82 1119.16 115.52 1033.79 115.52"
}), React.createElement("polygon", {
  id: "Path",
  points: "1158.41 39.25 1126.18 39.25 1126.18 -7.10542736e-15 1238.2 -7.10542736e-15 1238.2 39.25 1205.96 39.25 1205.96 115.52 1158.41 115.52"
})));

var SvgRepareerHet = function SvgRepareerHet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1239px",
    height: "117px",
    viewBox: "0 0 1239 117",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRepareerHet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/repareer-het.b033bfdb.svg";
export { ForwardRef as ReactComponent };